import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Phone, MessageCircle } from 'lucide-react';
import { pricing, contactInfo } from '../data/mock';
import { Link } from 'react-router-dom';

const Tarifs = () => {
  return (
    <div className="min-h-screen bg-black pt-20">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-b from-black to-black/95">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
            <span className="text-[#cbb26a]">Tarifs</span> de saillie
          </h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">
            Tarification simple et transparente
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-4">
          {/* Tarif principal */}
          <div className="max-w-4xl mx-auto mb-16">
            <Card className="bg-gradient-to-br from-[#cbb26a]/10 to-transparent border-[#cbb26a]/30 overflow-hidden">
              <div className="absolute top-0 right-0 w-64 h-64 bg-[#cbb26a]/5 rounded-full blur-3xl"></div>
              <CardContent className="p-12 relative">
                <div className="text-center mb-8">
                  <div className="text-6xl md:text-7xl font-bold text-[#cbb26a] mb-3">{pricing.studFee}€</div>
                  <div className="text-xl text-white/80">Saillie complète</div>
                </div>
                <div className="max-w-2xl mx-auto">
                  <h3 className="text-2xl font-bold text-white mb-6 text-center">Ce qui est inclus</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {pricing.included.map((item, index) => (
                      <div key={index} className="flex items-start space-x-3">
                        <CheckCircle size={24} className="text-[#cbb26a] flex-shrink-0 mt-1" />
                        <span className="text-white/90">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Details du paiement */}
          <div className="max-w-4xl mx-auto mb-16">
            <h2 className="text-3xl font-bold text-white mb-8 text-center">
              Modalités de <span className="text-[#cbb26a]">paiement</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {pricing.payment.map((item, index) => (
                <Card key={index} className="bg-white/5 border-[#cbb26a]/30 hover:bg-white/10 transition-all duration-300">
                  <CardContent className="p-6 text-center">
                    <CheckCircle size={32} className="text-[#cbb26a] mx-auto mb-4" />
                    <p className="text-white/90">{item}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* Garantie */}
          <div className="max-w-4xl mx-auto mb-16">
            <Card className="bg-white/5 border-[#cbb26a]/30">
              <CardHeader>
                <CardTitle className="text-2xl text-white text-center">
                  Notre <span className="text-[#cbb26a]">garantie</span>
                </CardTitle>
              </CardHeader>
              <CardContent className="text-center">
                <p className="text-white/80 text-lg mb-4">
                  Si la saillie n'aboutit pas à une gestation confirmée, nous vous offrons une re-saillie 
                  complètement gratuite lors des prochaines chaleurs de votre femelle.
                </p>
                <p className="text-[#cbb26a] font-semibold">
                  Votre satisfaction est notre priorité
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Informations supplementaires */}
          <div className="max-w-4xl mx-auto mb-16">
            <h2 className="text-3xl font-bold text-white mb-8 text-center">
              Informations <span className="text-[#cbb26a]">importantes</span>
            </h2>
            <div className="space-y-4">
              <Card className="bg-white/5 border-[#cbb26a]/30">
                <CardContent className="p-6">
                  <h3 className="text-[#cbb26a] font-semibold mb-2">Acompte de réservation</h3>
                  <p className="text-white/80">
                    Un acompte de 100€ est demandé pour confirmer votre réservation. Cet acompte sera déduit 
                    du montant total le jour de la saillie.
                  </p>
                </CardContent>
              </Card>
              <Card className="bg-white/5 border-[#cbb26a]/30">
                <CardContent className="p-6">
                  <h3 className="text-[#cbb26a] font-semibold mb-2">Paiement du solde</h3>
                  <p className="text-white/80">
                    Le solde de {pricing.studFee - 100}€ est à régler le jour de la première saillie, 
                    en espèces ou par virement bancaire.
                  </p>
                </CardContent>
              </Card>
              <Card className="bg-white/5 border-[#cbb26a]/30">
                <CardContent className="p-6">
                  <h3 className="text-[#cbb26a] font-semibold mb-2">Documents fournis</h3>
                  <p className="text-white/80">
                    Après la saillie, vous recevrez un certificat de saillie signé et tous les documents 
                    nécessaires pour la déclaration de la portée au LOF.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center bg-gradient-to-r from-[#cbb26a]/10 to-transparent rounded-xl p-12">
            <h3 className="text-3xl font-bold text-white mb-4">
              Prêt à réserver ?
            </h3>
            <p className="text-white/80 mb-8 max-w-2xl mx-auto">
              Contactez-nous pour réserver votre date ou poser vos questions
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                asChild
                size="lg"
                className="bg-[#cbb26a] text-black hover:bg-[#d4c485] transition-all duration-300"
              >
                <Link to="/contact">Réserver maintenant</Link>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-[#cbb26a] text-white hover:bg-[#cbb26a]/10 transition-all duration-300"
              >
                <a href={`https://wa.me/33${contactInfo.whatsapp.substring(1)}`} className="flex items-center space-x-2">
                  <MessageCircle size={20} />
                  <span>WhatsApp</span>
                </a>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tarifs;